import type { SearchableSelectOption } from '../../components/SearchableSelect';

/**
 * The people a request can be handed to: everyone but whoever has it now
 * and the person handing it off. Leatherback sends no email for a hand-off
 * to yourself, so offering it would look like a hand-off that silently
 * notifies nobody. Emails compare case-insensitively, as Leatherback does.
 */
export function handOffCandidates(
  people: readonly SearchableSelectOption[],
  assignee: string | undefined,
  me: string | undefined,
): SearchableSelectOption[] {
  const excluded = new Set(
    [assignee, me].filter((email): email is string => Boolean(email)).map((e) => e.toLowerCase()),
  );
  return people.filter((option) => option.value && !excluded.has(option.value.toLowerCase()));
}
